/**
 * 获取关注/粉丝列表
 */
export async function fetchFollowList(
  user_id: number,
  type: 'follow' | 'fans',
  last_id = 0
) {
  return http.get<{
    list: User.FollowListItem[]
  }>('/v1/follow/list', {
    user_id,
    type,
    last_id
  })
}
